/* src/app/pages/register-fuel/fuel-places-modal/fuel-places-modal.component.scss */
ion-searchbar {
  padding: 0;
  margin-bottom: 16px;
}
.list-description {
  display: block;
  width: 100%;
  color: #fff;
  padding: 12px;
}
.no-address-found {
  display: block;
  width: 100%;
  text-align: center;
  padding: 12px;
  color: #fff;
}
ion-searchbar {
  --background: #fff;
}
ion-list {
  border-radius: 10px;
  --background: #fff;
}
ion-item {
  --background: #fff;
}
/*# sourceMappingURL=fuel-places-modal.component.css.map */
